import { useState } from 'react';
import * as htmlToImage from 'html-to-image';

const useImageGenerator = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const generateImage = async (node: HTMLElement) => {
    setIsLoading(true);
    try {
      const dataUrl = await htmlToImage.toPng(node, {
        quality: 1,
        width: 200,
        height: 123,
      });

      const signatureResponse = await fetch(dataUrl);
      const currentSignatureBlob = await signatureResponse.blob();

      const file = new File(
        [currentSignatureBlob],
        `signature_${new Date().getTime()}`,
        { type: 'image/png' },
      );

      return file;
    } catch (error) {
      console.error('oops, something went wrong!', error);
    }
    setIsLoading(false);
  };

  return { generateImage, isLoading };
};

export default useImageGenerator;
